export const siteUrl = process.env.GATSBY_SITE_URL
export const siteCountry = process.env.GATSBY_SITE_COUNTRY

export const contactFormEndpoint = process.env.GATSBY_CONTACT_FORM_ENDPOINT
export const formPdfEndpoint = process.env.GATSBY_FORM_PDF_ENDPOINT
export const altchaUrl = process.env.GATSBY_ALTCHA_URL
export const altchaKey = process.env.GATSBY_ALTCHA_KEY
